import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { 
  getAuth, 
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Ensure the app is initialized (modular guard for hybrid/vanilla-React coexistence)
let app: FirebaseApp;
if (getApps().length) {
  app = getApp();
} else {
  // Only initialize if not already initialized by compat
  // These values should match your compat config or be injected via env if needed
  app = initializeApp({
    apiKey: import.meta.env.VITE_apiKey,
    authDomain: import.meta.env.VITE_authDomain,
    projectId: import.meta.env.VITE_projectId,
    storageBucket: import.meta.env.VITE_storageBucket,
    messagingSenderId: import.meta.env.VITE_messagingSenderId,
    appId: import.meta.env.VITE_appId,
    measurementId: import.meta.env.VITE_measurementId
  });
}

// Initialize and export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
// db.settings({ ignoreUndefinedProperties: true })

export const storage = getStorage(app);

export { 
  app,
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
};

export default { 
  app,
  auth, 
  db, 
  storage, 
  updateProfile, 
  updateEmail, 
  EmailAuthProvider, 
  reauthenticateWithCredential, 
  sendEmailVerification 
};
